import React from "react";
import UserSettingsHeader from "./UserSettingsHeader/UserSettingsHeader";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { DPPageWrapper } from "Components/DP";
import EmailSubscriptions from "./EmailSubscriptions/EmailSubscriptions";

const UserSettingsPage = () => {
  const { employer, permissions, offCyclePaymentOptions } = usePartnerConfig();
  const { firstName, lastName } = employer;

  return (
    <DPPageWrapper title="User Settings">
      <UserSettingsHeader firstName={firstName || ""} lastName={lastName || ""} />
      <EmailSubscriptions permissions={permissions} offCyclePaymentRequiresApproval={offCyclePaymentOptions.cycleRequiresApproval}/>
    </DPPageWrapper>
  );
};

export default UserSettingsPage;
